function makeBrownNoise(ctx, seconds) {
  const len = Math.floor(ctx.sampleRate * seconds);
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const data = buf.getChannelData(0);
  let last = 0;
  for (let i = 0; i < len; i++) {
    const white = Math.random() * 2 - 1;
    last = (last + 0.02 * white) / 1.02;
    data[i] = last * 3.5;
  }
  return buf;
}

function stamp(ctx, out, t) {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = "sine";
  o.frequency.setValueAtTime(110, t);
  o.frequency.exponentialRampToValueAtTime(45, t + 0.16);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(0.38, t + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 0.3);
  o.connect(g);
  g.connect(out);
  o.start(t);
  o.stop(t + 0.35);

  const nb = ctx.createBufferSource();
  nb.buffer = makeBrownNoise(ctx, 0.1);
  const hp = ctx.createBiquadFilter();
  hp.type = "highpass";
  hp.frequency.value = 1200;
  const ng = ctx.createGain();
  ng.gain.setValueAtTime(0.16, t);
  ng.gain.exponentialRampToValueAtTime(0.0001, t + 0.09);
  nb.connect(hp);
  hp.connect(ng);
  ng.connect(out);
  nb.start(t);
  nb.stop(t + 0.1);
}

export function playIntroSoundscape() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return () => {};

  const ctx = new Ctx();
  const master = ctx.createGain();
  master.gain.value = 0.55;
  master.connect(ctx.destination);
  const ambient = [];
  let stopped = false;

  const start = () => {
    if (stopped) return;
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const src = ctx.createBufferSource();
    src.buffer = makeBrownNoise(ctx, 4);
    src.loop = true;
    const lp = ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 380;
    lp.Q.value = 0.6;
    const wg = ctx.createGain();
    wg.gain.value = 0.13;
    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.11;
    const lg = ctx.createGain();
    lg.gain.value = 0.055;
    lfo.connect(lg);
    lg.connect(wg.gain);
    src.connect(lp);
    lp.connect(wg);
    wg.connect(master);
    src.start();
    lfo.start();
    ambient.push(src, lfo);

    const t0 = ctx.currentTime;
    stamp(ctx, master, t0 + 0.72);
  };

  const kick = () => {
    window.removeEventListener("pointerdown", kick);
    window.removeEventListener("keydown", kick);
    start();
  };

  if (ctx.state === "suspended") {
    window.addEventListener("pointerdown", kick);
    window.addEventListener("keydown", kick);
  } else {
    start();
  }

  return () => {
    stopped = true;
    window.removeEventListener("pointerdown", kick);
    window.removeEventListener("keydown", kick);
    try {
      master.gain.setTargetAtTime(0, ctx.currentTime, 0.1);
      ambient.forEach((n) => {
        try {
          n.stop(ctx.currentTime + 0.5);
        } catch {}
      });
      setTimeout(() => ctx.close().catch(() => {}), 600);
    } catch {}
  };
}


export function createWaveAmbience() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return { enter() {}, leave() {}, setMuted() {} };
  let ctx = null;
  let master = null;
  let inside = false;
  let muted = false;

  const LEVEL = 0.09;

  const apply = () => {
    if (!ctx) return;
    const target = !muted && inside ? LEVEL : 0;
    master.gain.setTargetAtTime(target, ctx.currentTime, 0.6);
  };

  const ensure = () => {
    if (ctx) return;
    ctx = new Ctx();
    master = ctx.createGain();
    master.gain.value = 0;
    master.connect(ctx.destination);
    const src = ctx.createBufferSource();
    src.buffer = makeBrownNoise(ctx, 4);
    src.loop = true;
    const lp = ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 320;
    lp.Q.value = 0.5;
    const wg = ctx.createGain();
    wg.gain.value = 0.5;
    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.09;
    const lg = ctx.createGain();
    lg.gain.value = 0.2;
    lfo.connect(lg);
    lg.connect(wg.gain);
    src.connect(lp);
    lp.connect(wg);
    wg.connect(master);
    src.start();
    lfo.start();
  };

  const enter = () => {
    ensure();
    if (ctx.state === "suspended") {
      ctx.resume().catch(() => {});
      const kick = () => {
        ctx.resume().catch(() => {});
        window.removeEventListener("pointerdown", kick);
        window.removeEventListener("keydown", kick);
      };
      window.addEventListener("pointerdown", kick);
      window.addEventListener("keydown", kick);
    }
    inside = true;
    apply();
  };

  const leave = () => {
    if (!ctx) return;
    inside = false;
    apply();
  };

  const setMuted = (m) => {
    muted = m;
    apply();
  };

  return { enter, leave, setMuted };
}
